// extracted by mini-css-extract-plugin
export default {"tradeFile":"DownloadFile_tradeFile__1U61q"};